import { httpDelete, httpGet, httpPost } from '../../../global/http-utils';
import { returnResponseIfOkOrSetGlobalErrorMessage } from '../../../global/api-utils';

export const getTenantUsers = (tenantId, userGroup) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/tenants/usergroup/users/${tenantId}/${userGroup}`),
    'An unexpected error occurred when getting users for tenant'
  );
};

export const addTenantUserToGroup = (tenantId, userId, userGroup) => {
  const requestBody = {
    userName: userId,
    userGroup: userGroup,
  };
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpPost(`tsi-multit/tenants/usergroup/users/${tenantId}`, requestBody),
    'An unexpected error occurred when adding user to group'
  );
};

export const removeTenantUserFromGroup = (tenantId, userId, userGroup) => {
  const requestBody = {
    userName: userId,
    userGroup: userGroup,
  };
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpDelete(`tsi-multit/tenants/usergroup/users/${tenantId}`, requestBody),
    'An unexpected error occurred when deleting user from group'
  );
};
